import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route, Switch } from "react-router-dom";
import React from "react";
import SEO from "../../UI/SEO/SEO";
import { getPreBasePath, getPreBaseRoute } from "../../../../components";
import MeetingSchedule from "./MeetingSchedule";
import MeetingAvailability from "./MeetingAvailability";
import MeetingConfirmation, { getMeetingConfirmationRoute, } from "./MeetingConfirmation";
import MeetingsDetail from "./MeetingsDetail";
import ParamsService from "../../../Services/Shared/Params.service";
export const getMeetingsBaseRoute = () => getPreBaseRoute() + "/app/meetings";
export const getMeetingsBasePath = (virtualizedApp) => getPreBasePath(virtualizedApp) + "/app/meetings";
export const getMeetingsScheduleRoute = () => getMeetingsBaseRoute() + "/schedule";
export const getMeetingsSchedulePath = ({ virtualizedApp, stableSearchParams, }) => {
    if (stableSearchParams) {
        return (getMeetingsBasePath(virtualizedApp) +
            "/schedule?" +
            ParamsService.toQueryString(Object.assign({}, stableSearchParams)));
    }
    return getMeetingsBasePath(virtualizedApp) + "/schedule";
};
export const getMeetingsConfirmationPath = ({ virtualizedApp, confirmationSearchParams, }) => getMeetingsBasePath(virtualizedApp) +
    "/confirm?" +
    ParamsService.toQueryString(Object.assign({}, confirmationSearchParams));
export const getMeetingsAvailabilityRoute = () => getMeetingsBaseRoute() + "/availability";
export const getMeetingsAvailabilityPath = (virtualizedApp) => getMeetingsBasePath(virtualizedApp) + "/availability";
export const getMeetingsDetailRoute = () => getMeetingsBaseRoute() + "/detail/:id";
export const getMeetingsDetailPath = (id, opts) => getMeetingsBasePath(opts === null || opts === void 0 ? void 0 : opts.virtualizedApp) + `/detail/${id}`;
const MeetingsRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Meetings" }), _jsxs(Switch, { children: [_jsx(Route, { component: MeetingSchedule, path: getMeetingsScheduleRoute() }), _jsx(Route, { component: MeetingAvailability, path: getMeetingsAvailabilityRoute() }), _jsx(Route, { component: MeetingConfirmation, path: getMeetingConfirmationRoute() }), _jsx(Route, { path: getMeetingsDetailRoute(), component: MeetingsDetail })] })] }));
export default MeetingsRoutes;
